
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

Vue.prototype.$eventBus = new Vue(); // Global event bus

import 'bootstrap/dist/css/bootstrap.min.css'
import * as uiv from 'uiv'
Vue.use(uiv);

import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';
Vue.use(VueIziToast);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('price-list-component', require('./components/views/PriceList').default);
Vue.component('import-treatments-component', require('./components/imports/TreatmentsTable').default);
Vue.component('dental-plan-component', require('./components/views/DentalPlan').default);
Vue.component('treatments-component', require('./components/views/Treatments').default);
Vue.component('health-insurance-component', require('./components/views/HealthInsurance').default);
Vue.component('patients-component', require('./components/views/Patients').default);
Vue.component('address-component', require('./components/AddressForm').default);
Vue.component('patient-general-data-component', require('./components/views/patient/medicalRecord/GeneralData').default);
Vue.component('patient-contracts-component', require('./components/views/patient/Contracts').default);
Vue.component('header-info-component', require('./components/views/patient/medicalRecord/HeaderInfo').default);
Vue.component('budget-create-component', require('./components/views/budget/CreateEdit').default);
Vue.component('top-bar-search-component', require('./components/TopBarSearch').default);
Vue.component('orthodontics-financial-component', require('./components/views/patient/orthodonticsFinancial/OrthodonticsFinancial').default);
Vue.component('orthodontics-component', require('./components/views/patient/orthodontics/Orthodontics').default);
Vue.component('orthodontics-planning-component', require('./components/views/patient/orthodontics/OrthodonticsPlanning').default);
Vue.component('attendance-component', require('./components/views/patient/implants/attendance/Attendance').default);
Vue.component('planning-component', require('./components/views/patient/implants/planning/Planning').default);
Vue.component('periodontics-attendance-component', require('./components/views/patient/periodontics/attendance/Attendance').default);
Vue.component('periodontics-planning-component', require('./components/views/patient/periodontics/planning/Planning').default);
Vue.component('bills-to-pay-component', require('./components/views/transactions/BillsToPay').default);
Vue.component('bills-to-receive-component', require('./components/views/transactions/BillsToReceive').default);

const app = new Vue({
    el: '#app'
});